/*
 * Countdown timer for the announcement bar.
 * Looks for <countdown-counter> elements and ticks them down to a target date.
 * Self-contained: no external libraries required.
 */
class CountdownCounter extends HTMLElement {
  constructor() {
    super();

    this.daysTime = this.querySelector('[data-countdown-days-time]');
    this.hoursTime = this.querySelector('[data-countdown-hours-time]');
    this.minutesTime = this.querySelector('[data-countdown-minutes-time]');
    this.secondsTime = this.querySelector('[data-countdown-seconds-time]');

    this.daysMetric = this.querySelector('[data-countdown-days-metric]');
    this.hoursMetric = this.querySelector('[data-countdown-hours-metric]');
    this.minutesMetric = this.querySelector('[data-countdown-minutes-metric]');
    this.secondsMetric = this.querySelector('[data-countdown-seconds-metric]');

    this.countdownTime = this.querySelectorAll('.countdown__time');

    const SECOND = 1000;
    this.units = {
      day: SECOND * 60 * 60 * 24,
      hour: SECOND * 60 * 60,
      minute: SECOND * 60,
      second: SECOND,
    };

    const defaults = {
      date: '1970-01-01T00:00:00+00:00',
      translations: {
        day_singular: 'Day',
        day_plural: 'Days',
        hour_singular: 'Hour',
        hour_plural: 'Hours',
        minute_singular: 'Min',
        minute_plural: 'Mins',
        second_singular: 'Sec',
        second_plural: 'Secs',
      },
    };

    let options = defaults;
    if (this.dataset.options) {
      try {
        const parsed = JSON.parse(this.dataset.options);
        options = {
          ...defaults,
          ...parsed,
          translations: { ...defaults.translations, ...(parsed.translations || {}) },
        };
      } catch (e) {
        /* if the date settings can't be read, fall back to defaults */
      }
    }

    this.t = options.translations;
    this.timeTarget = new Date(options.date);
    this.init();
  }

  init() {
    if (!(this.timeTarget instanceof Date) || isNaN(this.timeTarget) || this.timeTarget <= new Date()) {
      return;
    }
    this.countdownTime.forEach((el) => el.classList.remove('invisible'));
    this.render();
    this.timer = setInterval(() => this.render(), 1000);
  }

  render() {
    const diff = this.timeTarget - new Date();
    if (diff <= 0) {
      clearInterval(this.timer);
      return;
    }

    const days = Math.floor(diff / this.units.day);
    const hours = Math.floor((diff % this.units.day) / this.units.hour);
    const minutes = Math.floor((diff % this.units.hour) / this.units.minute);
    const seconds = Math.floor((diff % this.units.minute) / this.units.second);

    this.daysTime.textContent = String(days).padStart(2, '0');
    this.hoursTime.textContent = String(hours).padStart(2, '0');
    this.minutesTime.textContent = String(minutes).padStart(2, '0');
    this.secondsTime.textContent = String(seconds).padStart(2, '0');

    this.daysMetric.textContent = days === 1 ? this.t.day_singular : this.t.day_plural;
    this.hoursMetric.textContent = hours === 1 ? this.t.hour_singular : this.t.hour_plural;
    this.minutesMetric.textContent = minutes === 1 ? this.t.minute_singular : this.t.minute_plural;
    this.secondsMetric.textContent = seconds === 1 ? this.t.second_singular : this.t.second_plural;
  }
}

if (!customElements.get('countdown-counter')) {
  customElements.define('countdown-counter', CountdownCounter);
}
